<template>
    <div class="template template--basic">

        <loading v-if="isVerifying" :alt="true"></loading>

        <div class="login" v-else>

            <header class="login__header">
                <h1>De laatste stap!</h1>
                <p>Jouw account is bijna klaar. Vul nog even je naam in en het wachtwoord waarmee je de volgende keer kunt inloggen.</p>
            </header>

            <div class="login__panel-wrap">
                <div class="login__panel">

                    <form class="login__form">

                        <div class="input-group">
                            <label for="email" class="label--disabled">E-mail</label>
                            <input type="text" name="email" id="email" v-model="email" @keyup.enter.prevent="submit" disabled/>
                        </div>

                        <hr>

                        <div class="input-group" :class="{ error : containsError('firstname')}">
                            <label for="firstname">Voornaam</label>
                            <input type="text" name="firstname" id="firstname" v-model="firstname" @keyup.enter.prevent="submit" :autofocus="!isTouch" />
                        </div>

                        <div class="input-group" :class="{ error : containsError('infix')}">
                            <label for="infix">Tussenvoegsel <span class="example">— de / van / van 't / van den /  ...</span></label>
                            <input type="text" name="infix" id="infix" v-model="infix" @keyup.enter.prevent="submit" />
                        </div>

                        <div class="input-group" :class="{ error : containsError('lastname')}">
                            <label for="lastname">Achternaam</label>
                            <input type="text" name="lastname" id="lastname" v-model="lastname" @keyup.enter.prevent="submit" />
                        </div>

                        <hr>

                        <div class="input-group" :class="{ error : containsError('password')}">
                            <label for="password">Wachtwoord <span class="example">— minimaal 8 tekens</span></label>
                            <input type="password" name="password" id="password" v-model="password" @keyup.enter.prevent="submit" />
                        </div>

                        <div class="input-group" :class="{ error : containsError('passwordConfirmation')}">
                            <label for="passwordConfirmation">Herhaal wachtwoord</label>
                            <input type="password" name="passwordConfirmation" id="passwordConfirmation" v-model="passwordConfirmation" @keyup.enter.prevent="submit" />
                        </div>


                        <primary-button :link="{ name: 'root' }" @clicked="submit" :loading="loading" >Naar de werkmap</primary-button>

                    </form>

                </div>
            </div>

        </div>

    </div>
</template>


<script>
import api from 'js/api/resources';
import { login } from 'js/api/auth';
import notify from 'js/components/notifications/notificationsMixin';
import validation from 'js/components/auth/validationMixin';
import touch from 'js/components/auth/touchMixin';

import jwtDecode from 'jwt-decode'
import { transform } from 'js/vuex/helpers';
import PrimaryButton from 'js/components/elements/PrimaryButton.vue';
import Loading from 'js/components/elements/Loading.vue';

export default {
    name: 'RegisterVerify',
    mixins: [ notify, validation, touch ],
    components: { PrimaryButton, Loading },
    props: [],

    data: function() {
        return {
            firstname: '',
            infix: '',
            lastname: '',
            password: '',
            passwordConfirmation: '',
            email: '',
            loading: false,
            isVerifying: true,
            errors: [],
            errorFields: [],
        }
    },

    beforeRouteEnter: (to, from, next) => {

        if ( !to.params.token ) {
            return next({ name: 'register' })
        }

        next()

    },

    created: function() {

        api.registrationVerify(this.$route.params.token)
            .then( response => transform(response.body) )
            .then( result => {
                this.token = result.tokens[0].id
                const decoded = jwtDecode(this.token)
                this.email = decoded.sub
                this.isVerifying = false
            })
            .catch( () => {
                this.$warn('Deze activatie link is niet meer geldig')
                this.$router.push({ name: 'root' })
            })

    },

    methods: {
        submit: function(e) {

            e.preventDefault();

            if ( this.validate() ) {

                this.loading = true

                api.register(this.firstname, this.infix, this.lastname, this.password, this.passwordConfirmation, this.token)
                    .then( () =>

                        login(this.email, this.password)
                            .then( () => {
                                this.$success('Welkom ' + this.firstname, { id: 'validation' })
                                this.$router.push({ name: 'root' })
                            })
                    )
                    .catch( response => this.handleErrorResponse(response, 'Registratie is mislukt.') )
                    .then( () => this.loading = false)

            }

        },

        validateFields: function() {
            this.validateFirstName(this.firstname)
            this.validateLastName(this.lastname)
            this.validatePasswordLength(this.password)
            this.validatePasswordEqual(this.password, this.passwordConfirmation)
        },

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// RegisterVerify.vue?2dcec98a